module.exports = __webpack_public_path__ + "img/Cocos-Islands.3c0073f9.png";